import * as React from 'react';
import { connect } from 'react-redux';
import { inventory as inventoryAction } from '../../../../actions'
import { renderErrorObject } from '../../common/Render';

import LoadingCircle from '../../../loading/Circle';

import Widget from './Widget';
import ISettings from './ISettings';
import RemoteDataUtil from '../../util/RemoteDataUtil';
import { IReportSettings } from '../../../../interfaces';
import IState from '../../../../interfaces/states';

interface IWidgetData {
    nodes,
    states,
    inventory,
}

interface IProps {
    widgetId: string,
    widgetData: IWidgetData,
    listInventory: Function,
    settings: ISettings,
    reportSettings: IReportSettings,
}

export class WidgetContainer extends React.Component<IProps, void> {
    static propTypes = {
        widgetId: React.PropTypes.string.isRequired,
        listInventory: React.PropTypes.func.isRequired,
        settings: React.PropTypes.object.isRequired,
        reportSettings: React.PropTypes.object.isRequired,
    };

    fetchBaseData(props: IProps) {
        const { widgetId, listInventory, settings, reportSettings } = props;

        if (reportSettings.customerId) {
            listInventory(
                widgetId,
                {
                    customerId: reportSettings.customerId,
                    settings,
                    reportSettings,
                }
            );
        }
    }

    componentDidMount() {
        this.fetchBaseData(this.props);
    }

    componentWillReceiveProps(nextProps) {
        const { settings, reportSettings } = this.props;
        if (settings !== nextProps.settings || reportSettings !== nextProps.reportSettings) {
            this.fetchBaseData(nextProps);
        }
    }

    render() {
        const { widgetId, widgetData, settings, reportSettings } = this.props;
        let { inventory } = widgetData;
        const data = [inventory];
        // console.debug('::: inventory: ', inventory);

        if (!inventory || RemoteDataUtil.isLoading(data)) {
            return <LoadingCircle size="xxl" name={this.props.widgetId} infinite />;
        }

        if (RemoteDataUtil.isError(data)) {
            return renderErrorObject(widgetId, data);
        }

        return (
            <Widget inventory={inventory} settings={settings} reportSettings={reportSettings} />
        );
    }
}

const mapStateToProps = (state: IState, props: IProps) => ({
    widgetData: state.widgetData[props.widgetId] || { systems: null, jobs: null },
    reportSettings: state.reportSettings,
    settings: (state.reportTemplate.byId[props.widgetId] || {}).settings,
});

export default connect(
    mapStateToProps,
    {
        listInventory: inventoryAction.Inventory.listInventory
    }
)(WidgetContainer);


// WEBPACK FOOTER //
// ./src/components/widget/inventory/listInventory/WidgetContainer.tsx